import React, { useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./CropImageHelper";
import { jobCampaignsService } from "../../Services";

const BrandprofileImageCropper = ({
  imageUrl,
  setImageSrc,
  setCroppedImage,
  setSelectedImage,
  onUploadComplete,
}) => {
  const cropSizeVal = 250;
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cropSize] = useState({ width: cropSizeVal, height: cropSizeVal });
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [maxZoom, setMaxZoom] = useState(3);
  const [minZoom, setMinZoom] = useState(1);
  const [isUploading, setIsUploading] = useState(false);

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const onSliderChange = (event) => {
    if (event.target.value > minZoom) {
      setZoom(event.target.value);
    }
  };

  const handleZoomIn = () => {
    setZoom((prevZoom) => Math.min(prevZoom + 0.01, maxZoom));
  };

  const handleZoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 0.01, minZoom));
  };

  const onMediaLoaded = (media) => {
    const imageWidth = media.width;
    const imageHeight = media.height;
    const diffInDimension = Math.min(imageWidth, imageHeight);
    const zoomCalculated = cropSizeVal / diffInDimension;
    const maxZoomCalculated = zoomCalculated + 2;
    setZoom(zoomCalculated);
    setMinZoom(zoomCalculated);
    setMaxZoom(maxZoomCalculated);
  };


 const handleCrop = async () => {
  setIsUploading(true);

  try {
    const croppedImageUrl = await getCroppedImg(
      imageUrl,
      croppedAreaPixels,
      false
    );

    // 2. Convert base64 → File
    const response = await fetch(croppedImageUrl);
    const blob = await response.blob();

    const file = new File(
      [blob],
      `brand-logo-${Date.now()}.png`,
      { type: "image/png" }
    );

    // 3. Upload file
  
    const uploadResponse = await jobCampaignsService.uploadMedia(file);
    
    
    let data;
    if (typeof uploadResponse === 'string') {
      try {
        const decodedString = atob(uploadResponse);
        
        let parsedOnce = JSON.parse(decodedString);
        
        if (typeof parsedOnce === 'string') {
          data = JSON.parse(parsedOnce);
        } else {
          data = parsedOnce;
        }
      } catch (error) {
        console.error("Failed to decode/parse response:", error);
        try {
          data = JSON.parse(uploadResponse);
        } catch (parseError) {
          console.error("Failed to parse as JSON:", parseError);
          throw new Error("Invalid response from server");
        }
      }
    } else if (typeof uploadResponse === 'object') {
      data = uploadResponse;
    } else {
      throw new Error("Unexpected response type from server");
    }



    if (!data || typeof data !== 'object') {
      throw new Error("Upload failed: invalid response data");
    }

    const serverImageUrl = data.thumbnail_path || data.path || data.url || data.imageUrl;

    if (!serverImageUrl) {
      console.error("No image URL found in response. Data:", JSON.stringify(data, null, 2));
      throw new Error("Upload failed: no image URL received from server");
    }

  
    setCroppedImage(serverImageUrl);

    if (onUploadComplete) {
      onUploadComplete(serverImageUrl);
    }


    setSelectedImage(null);

  } catch (error) {
    console.error("Crop/upload error:", error);
    alert("Failed to upload image: " + error.message);
    throw error;
  } finally {
    setIsUploading(false);
  }
};

  return (
    <div className="profile-photo-container">
      <div className="cropper-modal">
        <div className="cropper-container">
          <Cropper
            image={imageUrl}
            onMediaLoaded={onMediaLoaded}
            crop={crop}
            zoom={zoom}
            aspect={cropSize.width / cropSize.height}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            cropSize={cropSize}
            cropShape="round"
            minZoom={minZoom}
            maxZoom={maxZoom}
          />
        </div>

        {/* Zoom Controls */}
        <div className="zoom-controls">
          <button onClick={handleZoomOut} disabled={isUploading}>
            -
          </button>
          <input
            type="range"
            min={minZoom}
            max={maxZoom}
            step={0.01}
            value={zoom}
            onChange={onSliderChange}
            disabled={isUploading}
          />
          <button onClick={handleZoomIn} disabled={isUploading}>
            +
          </button>
        </div>

        <div className="action-buttons modal__assetDetail-delete-btns">
          <button
            className="button secondary"
            onClick={() => setSelectedImage(null)}
            disabled={isUploading}
          >
            Cancel
          </button>
          <button
            className="button primary"
            onClick={handleCrop}
            disabled={isUploading}
          >
            {isUploading ? "Uploading..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BrandprofileImageCropper;
